import { render, staticRenderFns } from "./ShogaiRirekishoEdit.vue?vue&type=template&id=caa2fbe0&scoped=true"
import script from "./ShogaiRirekishoEdit.vue?vue&type=script&lang=js"
export * from "./ShogaiRirekishoEdit.vue?vue&type=script&lang=js"
import style0 from "./ShogaiRirekishoEdit.vue?vue&type=style&index=0&id=caa2fbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa2fbe0",
  null
  
)

export default component.exports